(() => {
  'use strict';
  const dialog = document.querySelector('.dk-video-dialog');
  let returnFocus = null;
  const allowedVideos = new Set(['Ev3NfC1WOmM', 'nGo24D3YWM0', 'r6aQ77ieDfo']);
  document.querySelectorAll('[data-dk-video]').forEach(link => {
    link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !dialog || typeof dialog.showModal !== 'function') return;
      const id = link.dataset.dkVideo;
      if (!allowedVideos.has(id)) return;
      event.preventDefault();
      returnFocus = link;
      const frame = document.createElement('iframe');
      frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
      frame.title = link.dataset.videoTitle || 'Dean Keating video';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      dialog.querySelector('.dk-video-frame').replaceChildren(frame);
      dialog.querySelector('.dk-video-external').href = `https://www.youtube.com/watch?v=${id}`;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    });
  });
  if (dialog) {
    dialog.querySelector('.dk-video-close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      dialog.querySelector('.dk-video-frame').replaceChildren();
      document.body.style.overflow = '';
      if (returnFocus && returnFocus.isConnected) returnFocus.focus();
    });
  }
  document.querySelectorAll('.dk-motion-control').forEach(button => {
    button.addEventListener('click', () => {
      const paused = document.body.classList.toggle('dk-motion-paused');
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? 'Resume motion' : 'Pause motion';
    });
  });
  const menu = document.querySelector('.dk-mobile-menu');
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu?.open) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  document.querySelectorAll('[data-dk-cta]').forEach(link => {
    link.addEventListener('click', () => {
      window.dispatchEvent(new CustomEvent('dk:cta', {detail: {placement: link.dataset.dkCta, destination: link.href}}));
    });
  });
})();
